export interface AuditApiCategory {
  category: string;
  action: string;
  flow: string;
  accessLevel?: 'public' | 'authenticated' | 'super admin';
  dataFlow: 'read' | 'write' | 'read-write';
}

export const auditApiCategories: { [key: string]: AuditApiCategory } = {

  // ==================== GENERAL & USER MANAGEMENT ====================
  'user-management/auth/change-password': {
    category: 'User Management',
    action: 'Update',
    flow: 'Change Password',
    accessLevel: 'authenticated',
    dataFlow: 'write'
  }
};
